/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconInfoSmall = createReactComponent("info-small", "IconInfoSmall", [
  ["path", { d: "M12 9h.01", key: "svg-0" }],
  ["path", { d: "M11 12h1v4h1", key: "svg-1" }]
]);

export { IconInfoSmall as default };
//# sourceMappingURL=IconInfoSmall.js.map
